module.exports = __webpack_public_path__ + "src/assets/img/championat.e891b95f.jpg";